module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/main-visual-ee9cb16912e410330997304c13978d78.jpg";